import { Type } from '@sinclair/typebox';
import {} from '@sinclair/typebox';
export const PoolFeesSchema = Type.Object({
    totalNetworkFees: Type.String({
        description: 'Native solana fee for consumed units. Paid to solana validators',
    }),
    totalPriorityFees: Type.String({
        description: 'Native solana fee for faster landing. Paid to solana validators',
    }),
    totalBundleTipFees: Type.String({
        description: 'Bundle fee for faster landing. Paid to providers like jito, 0slot',
    }),
    totalFees: Type.String({
        description: 'Sum of all fee components (network + priority + bundle tip)',
    }),
});
//# sourceMappingURL=pool-fees.js.map